import { createContext } from 'react';
export const TableContext = createContext({
    headerData: null,
    headerRows: null,
    rows: []
});
//# sourceMappingURL=TableContext.js.map